<template>
<div>
    <!-- Wholesaler List -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">Providers</div>
        </v-card-title>
        <v-card-text class="card">
            <v-row v-for="wholesaler in wholesalerList"
            :key="wholesaler.id"
            class="list-item"
            @click="selectWholesalerFromList(wholesaler)">
                <v-col class="py-0">
                    <v-row :id="wholesaler.wholesaler_id">
                        <v-col cols="12" style="font-size:18px;">
                            {{wholesaler.wholesaler_name}}
                            <v-icon v-if="wholesalerSelected.wholesaler_id === wholesaler.wholesaler_id" color="amber darken-2" small @click="editWholesalerButton">mdi-pencil-outline</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row></v-row>
        </v-card-text>
        <v-col></v-col>
    </v-card>

    <!-- Wholesaler Form -->
    <div v-if="this.wholesalerMode === this.modes.EDIT" class="mx-5">   
        <v-card outlined>
        <v-row class="ml-5">
            <v-col cols="8" >
                <v-row>
                    <div class="text-h4 primary--text font-weight-light">{{wholesalerSelected.wholesaler_name}}</div>
                    <span v-if="wholesalerHasChanges" class="warn">Changes are not saved!</span>
                </v-row>
            </v-col>
            <v-col cols="4" style="text-align:end;">
                <v-icon class="mr-5" color="grey" large @click="wholesalerMode=null">mdi-close</v-icon>
            </v-col>
        </v-row>
            <v-col cols="12" class="pb-0">
                <v-container class="pb-0">
                    <v-row no-gutters>
                        <v-col cols="12" class="p-0 pr-5">
                            <v-textarea
                                v-model="wholesalerSelected.about_terms"
                                label="About Terms"
                                class="pa-0 ma-0"
                                @change="wholesalerHasChanges = true">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="p-0 pr-5">
                            <v-textarea
                                v-model="wholesalerSelected.installation_credit_terms"
                                label="Installation Credit Terms"
                                class="pa-0 ma-0"
                                @change="wholesalerHasChanges = true">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="p-0 pr-5">
                            <v-textarea
                                v-model="wholesalerSelected.ongoing_credit_terms"
                                label="Ongoing Credit Terms"
                                class="pa-0 ma-0"
                                @change="wholesalerHasChanges = true">
                            </v-textarea>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="p-0 pl-5" style="text-align:end;">
                            <v-btn color="primary" dark @click="submitWholesalerForm">Save Changes</v-btn>
                        </v-col>
                    </v-row>
                    <v-col></v-col>
                </v-container>
            </v-col>
        </v-card>
    </div>

    <!-- RepUser List -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">Wholesalers</div>
        </v-card-title>
        <v-card-text class="card">
            <v-row v-for="repUser in repUserList"
            :key="repUser.rep_user_id"
            class="list-item"
            @click="selectRepUserFromList(repUser)">
                <v-col class="py-0">
                    <v-row :id="repUser.rep_user_id">
                        <v-col cols="12" style="font-size:18px;">
                            {{repUser.rep_name}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row></v-row>
        </v-card-text>
        <v-card-actions>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                    large
                    color="green lighten-2"
                    dark
                    class="ma-2"
                    v-on="on"
                    elevation=0
                    @click="newRepUserButton"
                    :disabled="repUserFormDisabled"
                    >
                    Add New Wholesaler
                    </v-btn>
                </template>
                <span>Create a new Wholesaler</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>

    <!-- RepUser Form -->
    <div class="mx-5">   
        <v-card outlined>
            <v-col class="ml-5">
                <div class="text-h4 primary--text font-weight-light">
                    {{repUserFormTitle}}
                    <span v-if="repUserHasChanges" class="warn">Changes are not saved!</span>
                </div>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-container class="pb-0">
                <v-row>
                    <v-col cols="6" class="px-5">
                        <v-text-field 
                            v-model="repUserSelected.rep_name"
                            :error-messages="repUserNameErrors"
                            label="* Name"
                            class="pa-0 ma-0"
                            required
                            @change="repUserHasChanges = true"
                            :disabled="repUserFormDisabled">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" class="px-5">
                        <v-text-field 
                            v-model="repUserSelected.rep_email"
                            :error-messages="repUserEmailErrors"
                            label="* Email"
                            class="pa-0 ma-0"
                            required
                            @change="repUserHasChanges = true"
                            :disabled="repUserFormDisabled">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="px-5" style="text-align:end;">
                        <v-btn 
                            color="primary" 
                            dark
                            @click="submitRepUserForm"
                            :disabled="repUserFormDisabled">Save Changes
                        </v-btn>
                    </v-col>
                </v-row>
                </v-container>
            </v-col>
        </v-card>
    </div>
<div style="min-height:200px;"></div>
</div>
  
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { RepUser, Wholesaler } from '@/store/modules/dataModels.js';

  export default {
    data: () => ({
        modes: {
            EDIT: 'edit',
            CREATE: 'create',
            DISABLE: 'disable',
        },
        wholesalerSelected: new Wholesaler(),
        wholesalerHasChanges: false,
        wholesalerMode: null,

        repUserSelected: new RepUser(),
        repUserHasChanges: false,
        repUserFormSubmitting: false,
        repUserMode: null
    }),

    mounted() {
        this.adminGetWholesalerList();
        this.adminClearRepUserLsit();
    },

    computed: {
        ...mapGetters({ 
            wholesalerList: 'getSiteAdmiWholesalerList',
            repUserList: 'getSiteAdminRepUserList',
        }),
        
        repUserFormTitle(){
            if (this.repUserMode === this.modes.EDIT){
                return `Edit: ${this.repUserSelected.rep_name}`
            } else {
                return "Add New Wholesaler"
            }
        },

        repUserFormDisabled(){
            if (this.wholesalerSelected.wholesaler_id === null) {
                return true;
            } else {
                return false;
            }
        },

        repUserNameErrors() {
            if (!this.repUserFormSubmitting) return [];
            const errors = [];
            if (this.repUserSelected.rep_name === null || this.repUserSelected.rep_name === "") {
                errors.push("Required");
            }
            return errors;
        },

        repUserEmailErrors() {
            if (!this.repUserFormSubmitting) return [];
            const errors = [];
            if (this.repUserSelected.rep_email === null || this.repUserSelected.rep_email === "") {
                errors.push("Required");
            }
            return errors;
        },
    },

    methods: {
        ...mapActions([
            'adminUpdateWholesaler',
            'adminGetWholesalerList',
            'adminCreateRepUser',
            'adminUpdateRepUser',
            'adminGetRepUserList',
            'adminClearRepUserLsit'
            ]),
        
        editWholesalerButton(){
            console.log('editWholesalerButton')
            if (this.wholesalerMode === this.modes.EDIT) {
                this.wholesalerMode = null;
            } else {
                this.wholesalerMode = this.modes.EDIT;
            }
            arguments[0].stopPropagation() //don't let the click event bubble up which would call this.selectWholesalerFromList
        },

        selectWholesalerFromList(wholesaler){
            console.log('selectWholesalerFromList')
            if (this.wholesalerMode === this.modes.EDIT) this.wholesalerMode = null;
            this.wholesalerSelected = wholesaler;
            this.wholesalerHasChanges = false;
            this.wholesalerFormSubmitting = false;
            this.changeSelectedElement(wholesaler.wholesaler_id,'wholesaler');

            this.adminGetRepUserList(wholesaler.wholesaler_id);
            this.repUserSelected = new RepUser({wholesaler_id:wholesaler.wholesaler_id});
            this.repUserHasChanges = false;
            this.repUserMode = this.modes.CREATE
            this.changeSelectedElement(null,'rep-user');
        },

        submitWholesalerForm(){
            this.adminUpdateWholesaler(this.wholesalerSelected);
            this.wholesalerHasChanges = false;
            this.changeSelectedElement(this.wholesalerSelected.wholesaler_id,'wholesaler');
            this.wholesalerMode = null;
            this.wholesalerSelected.selected = true;
        },

        newRepUserButton(){
            this.repUserHasChanges = false;
            this.repUserFormSubmitting = false;
            this.repUserMode = this.modes.CREATE
            this.repUserSelected = new RepUser({wholesaler_id:this.wholesalerSelected.wholesaler_id});
        },

        selectRepUserFromList(repUser){
            this.repUserHasChanges = false;
            this.repUserFormSubmitting = false;
            this.repUserMode = this.modes.EDIT;
            this.repUserSelected = repUser;
            this.changeSelectedElement(repUser.rep_user_id,'rep-user');
        },

        submitRepUserForm(){
            this.repUserFormSubmitting = true;
            if (this.repUserFormHasErrors()) return;
            if (this.repUserMode === this.modes.CREATE){
                this.adminCreateRepUser(this.repUserSelected.toJson());
                this.repUserHasChanges = false;
                this.repUserMode = this.modes.CREATE
                this.repUserSelected = new RepUser({wholesaler_id:this.wholesalerSelected.wholesaler_id});
                this.changeSelectedElement(null,'rep-user');
            } else if (this.repUserMode === this.modes.EDIT) {
                this.adminUpdateRepUser(this.repUserSelected);
                this.repUserHasChanges = false;
                this.changeSelectedElement(this.repUserSelected.rep_user_id,'rep-user');
            }
            this.repUserFormSubmitting = false;
        },

        repUserFormHasErrors(){
            let hasErrors = false
            let attrs = [this.repUserSelected.rep_name,this.repUserSelected.rep_email]
            attrs.forEach((attr) => {
                if (attr === null || attr === 'undefined' || attr === "") hasErrors = true
            })
            return hasErrors
        },

        changeSelectedElement(id,list){
            let eles = document.querySelectorAll(`.selected-${list}`)
            eles.forEach((e) => {
                e.classList.remove(`selected-${list}`);
                })
            if (id) {
                let ele = document.getElementById(id)
                ele.classList.add(`selected-${list}`)
            }
        },
    },
    components: { },
  };
</script>

<style scoped>
.list-item {
    cursor: pointer;
}
.list-item:hover {
    background-color: rgb(210, 230, 255)
}
.selected-wholesaler {
    border:1px solid blue;
    border-radius:4px;
}
.selected-rep-user {
    border:1px solid blue;
    border-radius:4px;
}
.warn {
    padding: 15px 0 0 15px;
    font-size: 16px;
    color: rgb(250, 100, 50);
}
.card {
    max-height:300px;
    min-height:300px;
    overflow-y:scroll;
    overflow-x:hidden;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>

